module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style3/menu-style3.component.scss
// module id = ./src/app/mega-menu/menu-style3/menu-style3.component.scss
// module chunks = main